"use client";

import { Component } from "react";
import loadScript from "load-script";
import { StoreContext } from "../../stores/StoreContext";
import { getConfig } from "../../_configs/AppConfig";
import { AppContextType } from "../../stores/StoreLoader";
const { publicRuntimeConfig } = getConfig();

export class MeritChat<P = {}, S = {}> extends Component<P, S> {
  static contextType = StoreContext;

  loginFunction = (): void => {
    const { modalStore } = this.context as AppContextType;
    modalStore.addModal({
      type: "login",
      size: "lg",
      id: "login-modal",
    });
  };

  onLoaded = () => {
    const { organizationStore } = this.context as AppContextType;
    if (typeof MC !== "undefined") {
      MC.hostname = publicRuntimeConfig.MERITCHAT_API_URL.replace(
        "https://",
        "",
      );
      MC.reactInit(
        organizationStore.currentOrganization.mcauth,
        this.loginFunction,
      );
    }
  };

  componentDidMount() {
    if (typeof MC === "undefined") {
      loadScript(
        `${publicRuntimeConfig.MERITCHAT_API_URL}/meritchat.js`,
        this.onLoaded,
      );
    }
  }
}

export class MeritChatThreadHeader extends MeritChat<{
  source_id: number;
  source_category: string;
  organization_id: string;
  language: string;
}> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <div
        className="meritchat thread-header"
        data-source-id={this.props.source_id}
        data-organization-id={this.props.organization_id}
        data-source-category={this.props.source_category}
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
        data-translate-from={this.props.language.split("-")[0]}
      />
    );
  }
}

export class MeritChatThread extends MeritChat<
  {
    source_id: number;
    source_category: string;
    organization_id: string;
    language: string;
  },
  any
> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <div
        className="meritchat thread"
        data-source-id={this.props.source_id}
        data-organization-id={this.props.organization_id}
        data-source-category={this.props.source_category}
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
        data-translate-from={this.props.language.split("-")[0]}
      />
    );
  }
}

export class MeritChatOrgReport extends MeritChat<
  {
    organization_id: string;
  },
  any
> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <div
        className="meritchat orgreport"
        data-source-org={this.props.organization_id}
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
      />
    );
  }
}

export class MeritChatModeratorMenu extends MeritChat {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <div
        className="meritchat moderator single"
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
      />
    );
  }
}
export class MeritChatThreadCTA extends MeritChat<{}, any> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <span
        className="meritchat thread-cta"
        data-source-id="1"
        data-source-category="custom.news"
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
      ></span>
    );
  }
}
